import React, { useState, useRef, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import $ from "jquery";
import {
  getSumAssuredValidation,
  setReturnalCalculatorData,
} from "../../actions/Utils";
import "react-datepicker/dist/react-datepicker.css";
import DateInput from "./DateInput";
import LangData from "../common/LangData";
import PremiumCalculatorDataPreview from "./PremiumCalculatorDataPreview";
import * as XLSX from "xlsx";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import { useHistory, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import axios from "axios";
import { modeMapping, planDefaultData, policyNameId } from "../../utils/utils";
import PolicyBuyButton from "./PolicyBuyButton";
import toast from "react-hot-toast";
import "./css/PremiumCalCulatorStyles.scss";

const toElifeDate = (value) =>
  typeof value === "string" ? value.replace(/\//g, "-") : value;
const PremiumcalCulatorform = ({ data, isModal = false, onApply, onClose, initialValues }) => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  // const history = useHistory();
  const location = useLocation();
  const lang = useSelector((state) => state.utils.lang);
  // const [term, setTerm] = useState([]);
  const returnCalculator = useSelector((state) => state.returnCalculator);
  const [returnCalculatorAllData, setReturnCalculatorAllData] = useState(
    returnCalculator?.calculation
  );
  const [calculatorPayload, setCalCulatorPayload] = useState({});

  useEffect(() => {
    if (isModal && initialValues) {
      if (initialValues.gender && genderRef.current) {
        genderRef.current.value = initialValues.gender;
      }
      setTimeout(() => {
        fetchPolicyData();
      }, 400);
    }
  }, [isModal]);
  const [state, setState] = useState({
    validator: {
      dob: "",
      doc: "",
      policy: "",
      term: "",
      sum_assured: "",
      term_rider: "",
      parentage: "",
      accidental_cover: "",
      mode: "",
      critical_illness: "",
      gender: "",
      critical_sum: "",
    },
    message: "",
    message_type: "",
    policy: {},
    terms: {},
    // modedata: {},
    styleinfo: {
      accidental: "none",
      licterm: "block",
      parentage: "none",
      critical: "none",
      gender: "block",
      critical_sum: "none",
      hospital_rider: "none",
      premiumPayment_term: "none",
      term_rider: "block",
    },
    calculation: {},
    criticalMax: 2000000,
  });
  const [disCal, setDisCal] = useState(false);
  const [policyData, setPolicyData] = useState([]);
  const [termsData, setTermsData] = useState([]);
  const [termsOption, setTermsOption] = useState([]);
  const [premiumPayingTermsData, setPremiumPayingTermsData] = useState([]);
  const [selectedPolicy, setSelectedPolicy] = useState([]);
  const [modesData, setModesData] = useState([]);

  const policyRef = useRef(null);
  const termRef = useRef(null);
  const premiumPayingTermsRefs = useRef(null);
  const sumAssuredRef = useRef(null);
  const accidentalCoverRef = useRef(null);
  const modeRef = useRef(null);
  const criticalIllnessRef = useRef(null);
  const genderRef = useRef(null);
  const criticalSumRef = useRef(null);
  const hospitalRiderRef = useRef(null);
  const propGenderRef = useRef(null);
  const pwbFlagRef = useRef(null);
  const termRiderRef = useRef(null);

  const handleMessageClose = () => {
    setState((prevState) => ({ ...prevState, message: "", message_type: "" }));
  };
  const handleValidatonReset = () => {
    const resetValidator = {
      dob: "",
      doc: "",
      policy: "",
      term: "",
      premiumPayingTerms: "",
      sum_assured: "",
      term_rider: "",
      parentage: "",
      accidental_cover: "",
      mode: "",
      critical_illness: "",
      gender: "",
      critical_sum: "",
      hospital_rider: "",
    };
    setState((prevState) => ({
      ...prevState,
      validator: { ...resetValidator },
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setDisCal(true);
    const parentage = $("#parent_age").val();
    const styleinfo = state.styleinfo;
    const userFormData = {
      dob: $("#dateofbirth").val(),
      doc: $("#dateofstartPolicy").val(),
      age: selectedPolicy?.age,
      policy: policyRef.current.value,
      term: styleinfo.licterm === "block" ? termRef.current.value : 0,
      premiumPayingTerm:
        styleinfo.premiumPayment_term === "block"
          ? premiumPayingTermsRefs.current.value
          : termRef.current.value,
      sum_assured: sumAssuredRef.current.value,
      term_rider: styleinfo.term_rider === "block" ? (termRiderRef.current?.value || "") : "",
      parentage: parentage && styleinfo.parentage === "block" ? parentage : 0,
      accidental_cover:
        styleinfo.accidental === "block" ? accidentalCoverRef.current.value : 0,
      critical_illness:
        policyRef.current.value === "807"
          ? "0"
          : styleinfo.critical === "block"
            ? criticalIllnessRef?.current?.value
            : 0,
      gender: genderRef.current.value ?? "",
      critical_sum:
        styleinfo.critical_sum === "block" ? criticalSumRef.current.value : 0,
      hospital_rider:
        styleinfo.hospital_rider === "block"
          ? hospitalRiderRef.current.value
          : 0,
      // mode: modeRef.current.value?.toLowerCase() === "S" ? "N" : modeRef.current.value,
      mode: modeRef.current.value,
      phone_number: "",
      propGender: styleinfo.parentage === "block" ? propGenderRef.current?.value || "M" : "M",
      pwbFlag:
        policyRef.current.value === "807"
          ? "N"
          : styleinfo.parentage === "block"
            ? pwbFlagRef.current?.value || "Y"
            : "0",
    };
    setCalCulatorPayload(userFormData);
    const resetValidator = {
      dob: "",
      doc: "",
      policy: "",
      term: "",
      sum_assured: "",
      term_rider: "",
      parentage: "",
      accidental_cover: "",
      mode: "",
      critical_illness: "",
      gender: "",
      critical_sum: "",
      hospital_rider: "",
    };

    const validation = {};
    if (userFormData.dob === "") {
      validation.dob = "This field is required.";
    }
    if (userFormData.doc === "") {
      validation.doc = "This field is required.";
    }
    if (userFormData.gender === "") {
      validation.gender = "This field is required.";
    }
    if (userFormData.policy === "") {
      validation.policy = "This field is required.";
    }
    if (userFormData.term === "" && styleinfo.licterm === "block") {
      validation.term = "This field is required.";
    }
    if (
      userFormData.premiumPayingTerm === "" &&
      styleinfo.premiumPayment_term === "block"
    ) {
      validation.premiumPayingTerms = "This field is required.";
    }
    if (userFormData.sum_assured === "") {
      validation.sum_assured = "This field is required.";
    }
    if (state?.validator?.sum_assured?.length > 0) {
      validation.sum_assured = state?.validator?.sum_assured;
    }
    if (
      styleinfo.term_rider === "block" &&
      userFormData.term_rider !== "" &&
      userFormData.term_rider !== null &&
      userFormData.term_rider !== undefined
    ) {
      const trVal = parseInt(userFormData.term_rider);
      const saVal = parseInt(userFormData.sum_assured || "0");
      if (!isNaN(trVal)) {
        if (trVal < 0) {
          validation.term_rider = "Amount cannot be negative";
        } else if (trVal > 0) {
          if (trVal < 50000) {
            validation.term_rider = "Minimum amount 50000";
          } else if (saVal > 0 && trVal > saVal) {
            validation.term_rider = `Maximum amount cannot be more than Sum Assured (${saVal})`;
          }
        }
      }
    }
    if (state?.validator?.term_rider?.length > 0) {
      validation.term_rider = state?.validator?.term_rider;
    }

    if (userFormData.parentage === "" && styleinfo.parentage === "block") {
      validation.parentage = "This field is required.";
    }
    if (
      userFormData?.accidental_cover === "" &&
      styleinfo.accidental === "block"
    ) {
      validation.accidental_cover = "This field is required.";
    }
    if (userFormData.mode === "") {
      validation.mode = "This field is required.";
    }
    if (criticalIllnessRef?.current?.value === "2") {
      if (userFormData.gender === "") {
        validation.gender = "This field is required";
      }
      if (userFormData?.critical_illness === "") {
        validation.critical_illness = "This field is required";
      }
      if (userFormData?.critical_sum === "") {
        validation.critical_sum = "This field is required";
      }
      if (userFormData?.hospital_rider === "") {
        validation.hospital_rider = "This field is required";
      } else {
        const sumAssured = sumAssuredRef.current.value / 2;
        const { criticalMax } = state;
        if (
          criticalSumRef.current.value > sumAssured ||
          criticalSumRef.current.value > criticalMax
        ) {
          validation.critical_sum =
            "Amount less than or equal to half of the sum assured (MAX: 2000000)";
        }
      }
    }

    if (Object.keys(validation)?.length) {
      setState((prevState) => ({
        ...prevState,
        validator: { ...resetValidator, ...validation },
        message: "",
      }));
      setDisCal(false);
    } else {
      try {
        // Calculate parent age if parentage is provided
        const parentAge = parentage ? calculateAge(parentage).toString() : "0";
        // Construct the payload
        const payload = {
          gender: userFormData?.gender,
          plan: userFormData?.policy,
          age: selectedPolicy?.age?.toString(),
          polTerm: userFormData?.term,
          ppTerm:
            styleinfo.premiumPayment_term === "block"
              ? userFormData?.premiumPayingTerm
              : userFormData?.term,
          polMode: userFormData?.mode,
          doc: userFormData?.doc ? toElifeDate(userFormData?.doc) : "2025-02-18",
          sa: userFormData?.sum_assured,
          abSa:
            userFormData?.accidental_cover === "1"
              ? userFormData?.sum_assured
              : "0",
          trSa: userFormData?.term_rider ? userFormData?.term_rider.toString() : "0",
          age2: "0",
          abSa2: "0",
          pwbFlag: userFormData.pwbFlag,
          propGender: userFormData.propGender,
          lf2CirSa: "0",
          propAge: parentAge, // Send the calculated parent age
          pprTrSa: "0",
          cirSa:
            userFormData.critical_illness === "0"
              ? "0"
              : userFormData.critical_illness === "1"
                ? parseInt(userFormData?.sum_assured) / 2
                : userFormData.critical_illness === "2"
                  ? userFormData?.critical_sum
                  : "0",
          premiumOption:
            userFormData?.policy === "807" && (userFormData?.hospital_rider === "0" || userFormData?.hospital_rider === 0)
              ? "1"
              : userFormData?.hospital_rider,
          scbSa:
            userFormData?.hospital_rider === "1"
              ? "100000"
              : userFormData?.hospital_rider === "2"
                ? "200000"
                : userFormData?.hospital_rider === "3"
                  ? "300000"
                  : userFormData?.hospital_rider === "4"
                    ? "400000"
                    : "0",
          hcbSa:
            userFormData?.hospital_rider === "1"
              ? "100000"
              : userFormData?.hospital_rider === "2"
                ? "200000"
                : userFormData?.hospital_rider === "3"
                  ? "300000"
                  : userFormData?.hospital_rider === "4"
                    ? "400000"
                    : "0",
          rdrDob: toElifeDate(
            parentage && styleinfo.parentage === "block"
              ? $("#parent_age").val()
              : $("#dateofbirth").val()
          ),
        };

        const response = await axios.post(
          `${process.env.REACT_APP_BACKEND_URL}/api/premiumCalculator/calcPremium`,
          payload,
          { headers: { "Content-Type": "application/json" } }
        );

        const res = response?.data;
        console.log("API Response:", res, res?.premCalcErr);
        if (res?.message === "Success") {
          const policyName =
            policyNameId[userFormData.policy] || "Unknown Policy";
          const prevResponse = {
            customer_name: false,
            policy: policyName,
            age: selectedPolicy?.age?.toString(),
            sum_assured: userFormData?.sum_assured,
            term: userFormData?.term,
            mode: userFormData?.mode,
            premium_amount: res?.instPrem,
            critical_illness_benefit: 0,
            critical_illness_amount: 0,
          };

          setState((prevState) => ({
            ...prevState,
            calculation: {
              ...res,
              ...prevResponse,
              payload: { ...userFormData, ...payload },
              accidental_cover:
                styleinfo.accidental === "block"
                  ? accidentalCoverRef.current.value
                  : 0,
              critical_illness:
                styleinfo.critical === "block"
                  ? criticalIllnessRef?.current?.value
                  : 0,
              gender:
                styleinfo.gender === "block" ? genderRef.current.value : "M",
              critical_sum:
                styleinfo.critical_sum === "block"
                  ? criticalSumRef.current.value
                  : 0,
              hospital_rider:
                styleinfo.hospital_rider === "block"
                  ? hospitalRiderRef.current.value
                  : 0,
            },
            message: "",
            message_type: "success",
            validator: { ...resetValidator },
          }));
        } else {
          toast.error("Failed to calculate.");
          setState((prevState) => ({
            ...prevState,
            calculation: {},
          }));
          dispatch(setReturnalCalculatorData({}));
        }
      } catch (error) {
        console.error("Error in fetching calculation:", error);
      } finally {
        setDisCal(false);
      }
    }
  };

  const handleSumAssuredValidation = () => {
    handleValidatonReset();
    const policy = policyRef.current?.value;
    const sum_assured = sumAssuredRef.current?.value;
    if (!policy) {
      setState((prevState) => ({
        ...prevState,
        validator: {
          ...prevState.validator,
          policy: "First you have to select policy",
        },
      }));
      return;
    }
    if (sum_assured) {
      const selectedPolicyData = selectedPolicy?.planDetails?.[0];
      if (selectedPolicyData) {
        const {
          minimumSumAssuredRegularPremium,
          maximumSumAssuredRegularPremium,
          minimumSumAssuredSinglePremium,
          maximumSumAssuredSinglePremium,
          saMultiples,
        } = selectedPolicyData;
        const sumAssuredNum = parseInt(sum_assured);
        let validationMessages = [];

        // Check if modesData is exactly ['N']
        const isSinglePremium = modesData?.length === 1 && modesData[0] === "N";
        const minAmount = isSinglePremium
          ? minimumSumAssuredSinglePremium
          : minimumSumAssuredRegularPremium;
        const maxAmount = isSinglePremium
          ? maximumSumAssuredSinglePremium
          : maximumSumAssuredRegularPremium;

        if (sumAssuredNum < minAmount) {
          validationMessages.push(`Minimum amount ${minAmount}`);
        }
        if (sumAssuredNum > maxAmount) {
          validationMessages.push(`Maximum amount ${maxAmount}`);
        }
        if (sumAssuredNum % saMultiples !== 0) {
          validationMessages.push(
            `Amount should be multiple of ${saMultiples}`
          );
        }

        setState((prevState) => ({
          ...prevState,
          validator: {
            ...prevState.validator,
            sum_assured:
              validationMessages.length > 0
                ? validationMessages.join(", ")
                : "",
          },
        }));
      }
    }
  };

  const handleTermRiderValidation = () => {
    const sum_assured = sumAssuredRef.current?.value;
    const term_rider = termRiderRef.current?.value;
    if (term_rider !== undefined && term_rider !== "" && term_rider !== null) {
      const trValue = parseInt(term_rider);
      const saValue = parseInt(sum_assured || "0");
      let validationMessages = [];
      const minAmount = 50000;
      const maxAmount = saValue;

      if (!isNaN(trValue)) {
        if (trValue < 0) {
          validationMessages.push("Amount cannot be negative");
        } else if (trValue > 0) {
          if (trValue < minAmount) {
            validationMessages.push(`Minimum amount ${minAmount}`);
          }
          if (saValue > 0 && trValue > maxAmount) {
            validationMessages.push(
              `Maximum amount cannot be more than Sum Assured (${maxAmount})`
            );
          }
        }
        // If trValue === 0, it is valid without error
      }

      setState((prevState) => ({
        ...prevState,
        validator: {
          ...prevState.validator,
          term_rider:
            validationMessages.length > 0 ? validationMessages.join(", ") : "",
        },
      }));
    } else {
      setState((prevState) => ({
        ...prevState,
        validator: {
          ...prevState.validator,
          term_rider: "",
        },
      }));
    }
  };

  const handleModeData = () => {
    const policy = policyRef.current.value;
    let modeData = [];
    if (
      policy === "803" ||
      policy === "816" ||
      policy === "8141" ||
      policy === "8151" ||
      policy === "809"
    ) {
      modeData = ["N"];
    }
    if (policy === "811") {
      modeData = ["Y", "H"];
    }
    if (
      policy === "801" ||
      policy === "802" ||
      policy === "806" ||
      policy === "807" ||
      policy === "808" ||
      policy === "810"
    ) {
      modeData = ["M", "Q", "H", "Y"];
    }
    // Only update state if we have modeData
    if (modeData.length > 0) {
      setModesData(modeData);
    }
  };
  const resetForm = () => {
    if (termRef.current) termRef.current.value = "";
    if (premiumPayingTermsRefs.current)
      premiumPayingTermsRefs.current.value = "";
    if (sumAssuredRef.current) sumAssuredRef.current.value = "";
    if (termRiderRef.current) termRiderRef.current.value = "";
    if (accidentalCoverRef.current) accidentalCoverRef.current.value = "";
    if (modeRef.current) modeRef.current.value = "";
    if (criticalIllnessRef.current)
      criticalIllnessRef.current.value = policyRef.current?.value === "807" ? "0" : "";
    if (criticalSumRef.current) criticalSumRef.current.value = "";
    if (hospitalRiderRef.current) hospitalRiderRef.current.value = "";
    if (propGenderRef.current) propGenderRef.current.value = "M";
    if (pwbFlagRef.current)
      pwbFlagRef.current.value = policyRef.current?.value === "807" ? "N" : "Y";
    const resetValidator = {
      term: "",
      premiumPayingTerms: "",
      sum_assured: "",
      term_rider: "",
      parentage: "",
      accidental_cover: "",
      mode: "",
      critical_illness: "",
      critical_sum: "",
      hospital_rider: "",
    };
    // Reset validator state
    setState((prevState) => ({
      ...prevState,
      validator: { ...resetValidator },
    }));
  };

  const fetchPolicyData = async () => {
    const gender = genderRef.current.value;
    const dob = $("#dateofbirth").val();
    const doc = $("#dateofstartPolicy").val();

    if (!dob || !doc || !gender) return;
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_BACKEND_URL}/api/premiumCalculator/eligiblePlans`,
        { dob: toElifeDate(dob), doc: toElifeDate(doc), gender, ageProof: "P" },
        { headers: { "Content-Type": "application/json" } }
      );

      if (response.status === 200) {
        // const filteredPlans = response?.data?.plans?.filter(
        //   (plan) => plan.plan !== 807
        // );

        const filteredPlans = response?.data?.plans?.filter(
          (plan) => plan.plan
        );
        if (filteredPlans?.length > 0) {
          setPolicyData(filteredPlans);
        } else {
          toast.success("No plan found.");
        }

        resetForm();
      }
    } catch (error) {
      console.error("Error fetching policies", error);
      toast.error(
        error?.response?.data?.message || "Failed to load plan list."
      );
    }
  };
  const handlePolicyChange = (e) => {
    const selectedPolicyId = e.target.value;
    const selectedPolicy = policyData?.find(
      (p) => p.plan.toString() === selectedPolicyId
    );
    if (selectedPolicy) {
      setSelectedPolicy(selectedPolicy);
      let filteredTerms = selectedPolicy.planDetails[0].termsAllowed;

      // Filter out terms 3 and 4 if plan is 814
      if (selectedPolicy.plan === 814) {
        filteredTerms = filteredTerms?.filter(
          (term) => term.policyTerm !== 3 && term.policyTerm !== 4
        );
      }
      setTermsData(filteredTerms);
      if (selectedPolicy.planDetails[0].policyModesAllowed) {
        setModesData(selectedPolicy.planDetails[0].policyModesAllowed);
      }
      handleModeData();
    } else {
      setSelectedPolicy([]);
      setTermsData([]);
      setModesData([]);
    }
    handleOptionShowHide(selectedPolicyId);
    resetForm();
  };

  const handleOptionShowHide = (selectedPolVal, selectedModeVal) => {
    const policy =
      selectedPolVal !== undefined ? selectedPolVal : policyRef.current?.value;
    const mode =
      selectedModeVal !== undefined ? selectedModeVal : modeRef.current?.value;
    const conditionalData = {
      accidental: "block",
      licterm: "block",
      parentage: "none",
      critical: "none",
      gender: "none",
      critical_sum: "none",
      premiumPayment_term: "none",
      hospital_rider: "none",
      term_rider: mode === "N" ? "none" : "block",
    };

    switch (policy) {
      case "802":
        conditionalData.critical = "block";
        conditionalData.hospital_rider = "block";
        conditionalData.accidental = "block";
        conditionalData.parentage = "none";
        break;
      case "803":
        conditionalData.hospital_rider = "none";
        conditionalData.accidental = "none";
        conditionalData.critical = "none";
        break;
      case "804":
        conditionalData.critical = "block";
        conditionalData.hospital_rider = "block";
        break;
      case "805":
        conditionalData.hospital_rider = "block";
        break;
      case "806":
        conditionalData.accidental = "block";
        conditionalData.critical = "block";
        conditionalData.hospital_rider = "block";
        break;
      case "807":
        conditionalData.parentage = "block";
        conditionalData.licterm = "block";
        conditionalData.premiumPayment_term = "block";
        conditionalData.accidental = "none";
        conditionalData.critical = "block";
        conditionalData.hospital_rider = "block";
        break;

      case "808":
        conditionalData.critical = "block";
        conditionalData.hospital_rider = "block";
        break;
      case "809":
        conditionalData.hospital_rider = "none";
        conditionalData.accidental = "none";
        break;
      case "811":
      case "813":
        conditionalData.critical = "block";
        conditionalData.hospital_rider = "block";
        break;
      case "814":
        conditionalData.critical = "block";
        conditionalData.hospital_rider = "block";
        conditionalData.accidental = "block";
        break;
      case "815":
        conditionalData.critical = "block";
        // conditionalData.gender = "block";
        conditionalData.accidental = "block";
        conditionalData.hospital_rider = "block";
        break;

      case "816":
      case "8141":
      case "8151":
        conditionalData.accidental = "none";
        break;
      default:
        conditionalData.parentage = "none";
        conditionalData.licterm = "block";
    }
    const policiesToCheck = ["801", "802", "813"];

    if (policiesToCheck.includes(policy)) {
      conditionalData.premiumPayment_term = "none";
    } else {
      conditionalData.premiumPayment_term = "block";
    }

    // Single premium Endowment (803), Grow fast (809), Jibon Shanti (816): Term Rider will not come
    if (policy === "803" || policy === "809" || policy === "816") {
      conditionalData.term_rider = "none";
      if (termRiderRef.current) termRiderRef.current.value = "";
    }

    // When mode is Single ("N"): no riders will come (Term Rider, Accidental cover, Critical illness, Hospital rider)
    if (mode === "N") {
      conditionalData.term_rider = "none";
      conditionalData.accidental = "none";
      conditionalData.critical = "none";
      conditionalData.critical_sum = "none";
      conditionalData.hospital_rider = "none";

      if (termRiderRef.current) termRiderRef.current.value = "";
      if (accidentalCoverRef.current) accidentalCoverRef.current.value = "";
      if (criticalIllnessRef.current) criticalIllnessRef.current.value = "";
      if (criticalSumRef.current) criticalSumRef.current.value = "";
      if (hospitalRiderRef.current) hospitalRiderRef.current.value = "";
    }

    setState((prevState) => ({
      ...prevState,
      validator: {
        ...prevState.validator,
        ...(conditionalData.term_rider === "none" ? { term_rider: "" } : {}),
        ...(conditionalData.accidental === "none" ? { accidental_cover: "" } : {}),
        ...(conditionalData.critical === "none" ? { critical_illness: "", critical_sum: "" } : {}),
        ...(conditionalData.hospital_rider === "none" ? { hospital_rider: "" } : {}),
      },
      styleinfo: {
        ...prevState.styleinfo,
        ...conditionalData,
      },
    }));
  };

  const handleCriticalIllnessChange = () => {
    setState((prevState) => ({
      ...prevState,
      styleinfo: {
        ...prevState.styleinfo,
        critical_sum:
          criticalIllnessRef.current.value === "2" ? "block" : "none",
      },
    }));
  };

  useEffect(() => {
    if (Object.keys(calculatorPayload)?.length > 0) {
      dispatch(
        setReturnalCalculatorData({
          ...state.calculation,
          dateOf_birth: calculatorPayload?.dob,
          payload: state.calculation?.payload,
        })
      );
      // dispatch(
      //   setReturnalCalculatorData({
      //     ...state.calculation,
      //     calculatorPayload: calculatorPayload,
      //     // payload: state.calculation?.payload,
      //   })
      // );
    }
  }, [state.calculation]);

  useEffect(() => {
    setState((prevState) => ({
      ...prevState,
      calculation: {
        ...returnCalculatorAllData,
      },
    }));
  }, [returnCalculatorAllData]);

  // const contents = data?.content;
  const { validator, styleinfo, calculation } = state;
  // console.log("conditionalData.accidental 33333333333", styleinfo);
  const data_loop = [];
  var cumalitive_total = 0;
  var total_20 = 0;
  var total_40 = 0;
  var totalSurvivalBenefit = 0;
  var totalFac = 0;

  if (calculation) {
    var final_premium_amount;

    if (calculation?.payload?.mode == "Y") {
      final_premium_amount = parseInt(calculation.instPrem);
    } else if (calculation?.payload?.mode == "H") {
      final_premium_amount = parseInt(calculation.instPrem) * 2;
    } else if (calculation?.payload?.mode == "Q") {
      final_premium_amount = parseInt(calculation.instPrem) * 4;
    } else if (calculation?.payload?.mode == "M") {
      final_premium_amount = parseInt(calculation.instPrem) * 12;
    } else if (calculation?.payload?.mode == "S") {
      final_premium_amount = parseInt(calculation.instPrem) * 1;
    }

    for (let i = 1; i <= parseInt(calculation?.payload?.term); i++) {
      total_20 += parseInt(calculation?.payload?.sum_assured) * 0.02;
      total_40 += parseInt(calculation?.payload?.sum_assured) * 0.04;
      if (i !== parseInt(calculation.term)) {
        totalSurvivalBenefit +=
          parseInt(calculation?.payload?.sum_assured) * 0.1;
      }

      if (parseInt(calculation.term) === 6) {
        if (i === 1) {
          totalFac += final_premium_amount * 0.12;
        } else {
          totalFac += final_premium_amount * 0.05;
        }
      } else if (parseInt(calculation.term) === 9) {
        if (i === 1) {
          totalFac += final_premium_amount * 0.18;
        } else if (i === 2) {
          totalFac += final_premium_amount * 0.1;
        } else {
          totalFac += final_premium_amount * 0.05;
        }
      } else if (parseInt(calculation.term) === 12) {
        if (i === 1) {
          totalFac += final_premium_amount * 0.25;
        } else if (i === 2) {
          totalFac += final_premium_amount * 0.1;
        } else {
          totalFac += final_premium_amount * 0.05;
        }
      }

      cumalitive_total += final_premium_amount;
      data_loop.push(cumalitive_total);
    }
  }
  useEffect(() => {
    if (Object.keys(selectedPolicy)?.length > 0) {
      if (selectedPolicy) {
        setSelectedPolicy(selectedPolicy);
        let filteredTerms = selectedPolicy.planDetails[0].termsAllowed;

        // Filter out terms 3 and 4 if plan is 814
        if (selectedPolicy.plan === 814) {
          filteredTerms = filteredTerms?.filter(
            (term) => term.policyTerm !== 3 && term.policyTerm !== 4
          );
        }

        setTermsData(filteredTerms);
        // setModesData(selectedPolicy.planDetails[0].policyModesAllowed);
      }
    }
  }, [selectedPolicy]);

  const handleModeChange = (event) => {
    const selectedMode = event.target.value;
    handleOptionShowHide(undefined, selectedMode);
    if (selectedPolicy) {
      if (
        (selectedPolicy.plan === 815 && selectedMode === "N") ||
        (selectedPolicy.plan === 814 && selectedMode === "N")
      ) {
        const defaultTermData = {
          policyTerm: 5,
          premiumPayingTermAllowed: [1],
        };
        setTermsData([defaultTermData]);
      } else {
        let filteredTerms = selectedPolicy.planDetails[0].termsAllowed;
        setTermsData(filteredTerms);
      }
    }
  };
  const handleTermChange = (event) => {
    const selectedTerm = event.target.value;
    const selectedTermData = termsData.find(
      (term) => term.policyTerm === parseInt(selectedTerm)
    );

    if (selectedTermData) {
      if (
        (selectedPolicy.plan === 815 || selectedPolicy.plan === 814) &&
        modeRef.current.value !== "N"
      ) {
        // For mode N, remove term 1 from premiumPayingTermAllowed
        const filteredPremiumPayingTerms =
          selectedTermData.premiumPayingTermAllowed.filter((ppt) => ppt !== 1);
        setPremiumPayingTermsData(filteredPremiumPayingTerms);
      } else {
        setPremiumPayingTermsData(selectedTermData.premiumPayingTermAllowed);
      }
    } else {
      setPremiumPayingTermsData([]);
    }
  };

  const handlePremiumPayingTermChange = (event) => {
    const selectedTerm = event.target.value;

    if (selectedPolicy) {
      if (
        (selectedPolicy.plan === 814 && selectedTerm === "1") ||
        (selectedPolicy.plan === 815 && selectedTerm === "1")
      ) {
        setState((prevState) => ({
          ...prevState,
          styleinfo: {
            ...prevState.styleinfo,
            accidental: "none",
            critical: "none",
            hospital_rider: "none",
          },
        }));
      } else {
        // if (selectedPolicy.plan === 814) {
        //   setState((prevState) => ({
        //     ...prevState,
        //     styleinfo: {
        //       ...prevState.styleinfo,
        //       accidental: "block",
        //       critical: "block",
        //       hospital_rider: "block",
        //     },
        //   }));
        // }
        // if (selectedPolicy.plan === 815) {
        //   setState((prevState) => ({
        //     ...prevState,
        //     styleinfo: {
        //       ...prevState.styleinfo,
        //       accidental: "block",
        //       critical: "block",
        //       hospital_rider: "block",
        //     },
        //   }));
        // }
      }
    }
  };

  useEffect(() => {
    if (location.state?.fromPolicyBuy !== true) {
      setState((prevState) => ({
        ...prevState,
        calculation: {},
      }));
      dispatch(setReturnalCalculatorData({}));
    }
  }, [location.state, dispatch]);

  useEffect(() => {
    if (termsData?.length > 0) {
      // Remove duplicate policyTerm values
      const uniqueTerms = Array.from(
        new Map(termsData.map((item) => [item.policyTerm, item])).values()
      );

      setTermsOption(uniqueTerms);
    } else {
      setTermsOption([]);
    }
  }, [termsData]);

  const calculateAge = (dob) => {
    const birthDate = new Date(dob);
    const today = new Date();
    let age = today.getFullYear() - birthDate.getFullYear();
    const monthDiff = today.getMonth() - birthDate.getMonth();

    if (
      monthDiff < 0 ||
      (monthDiff === 0 && today.getDate() < birthDate.getDate())
    ) {
      age--;
    }
    return age;
  };

  const handleParentAgeValidation = () => {
    const parentAge = $("#parent_age").val();
    if (parentAge) {
      const age = calculateAge(parentAge);
      if (age < 18 || age > 55) {
        setState((prevState) => ({
          ...prevState,
          validator: {
            ...prevState.validator,
            parentage: "Parent age must be between 18-55 years.",
          },
        }));
        setDisCal(true);
      } else {
        setState((prevState) => ({
          ...prevState,
          validator: {
            ...prevState.validator,
            parentage: "",
          },
        }));
        setDisCal(false);
      }
    }
  };

  const handleDownloadExcel = () => {
    // Prepare table data
    const tableData = [
      ["Plan Name", calculation?.policy || ""],
      ["Customer Age", calculation?.age || ""],
      ["Sum Assured", calculation?.payload?.sum_assured || ""],
      ["Term", calculation?.payload?.term || ""],
      ["Mode", modeMapping[calculation?.payload?.mode] || calculation?.payload?.mode || ""],
      ["Approximate Premium", calculation?.totPrem ?? "0"],
    ];

    // Add optional rows based on conditions
    if (calculation?.payload?.polMode !== "N" &&
      ["802", "801", "804", "805", "806", "808", "813", "815", "814"].includes(calculation?.payload?.plan)) {
      tableData.push(["Accidental Coverage", calculation?.payload?.accidental_cover === "0" ? "No" : "Yes"]);
    }

    if (calculation?.payload?.polMode !== "N" &&
      ["802", "804", "805", "806", "807", "808", "813", "815", "814"].includes(calculation?.payload?.plan)) {
      tableData.push(["Hospital Rider Benefit", calculation?.payload?.hcbSa === "0" ? "No" : calculation?.payload?.hcbSa]);
    }

    if (calculation?.payload?.polMode !== "N" &&
      ["802", "804", "806", "807", "808", "813", "814", "815"].includes(calculation?.payload?.plan)) {
      let criticalIllnessValue = "No";
      if (calculation?.payload?.critical_illness === "1") {
        criticalIllnessValue = parseInt(calculation?.sum_assured) / 2;
      } else if (calculation?.payload?.critical_illness === "2") {
        criticalIllnessValue = calculation?.critical_sum;
      }
      tableData.push(["Critical Illness", criticalIllnessValue]);
    }

    const ws = XLSX.utils.aoa_to_sheet([["Field", "Value"], ...tableData]);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "PremiumResult");
    XLSX.writeFile(wb, "Premium_Calculation_Result.xlsx");
  };

  const handleDownloadPDF = () => {
    try {
      console.log("Starting PDF generation...");

      const doc = new jsPDF();

      // Add Title
      doc.setFontSize(18);
      doc.text("Premium Calculation Result", 14, 20);

      // Prepare table data
      const tableData = [
        ["Plan Name", calculation?.policy || ""],
        ["Customer Age", calculation?.age || ""],
        ["Sum Assured", calculation?.payload?.sum_assured || ""],
        ["Term", calculation?.payload?.term || ""],
        ["Mode", modeMapping[calculation?.payload?.mode] || calculation?.payload?.mode || ""],
        ["Approximate Premium", calculation?.totPrem ?? "0"],
      ];

      // Add optional rows based on conditions
      if (calculation?.payload?.polMode !== "N" &&
        ["802", "801", "804", "805", "806", "808", "813", "815", "814"].includes(calculation?.payload?.plan)) {
        tableData.push(["Accidental Coverage", calculation?.payload?.accidental_cover === "0" ? "No" : "Yes"]);
      }

      if (calculation?.payload?.polMode !== "N" &&
        ["802", "804", "805", "806", "807", "808", "813", "815", "814"].includes(calculation?.payload?.plan)) {
        tableData.push(["Hospital Rider Benefit", calculation?.payload?.hcbSa === "0" ? "No" : calculation?.payload?.hcbSa]);
      }

      if (calculation?.payload?.polMode !== "N" &&
        ["802", "804", "806", "807", "808", "813", "814", "815"].includes(calculation?.payload?.plan)) {
        let criticalIllnessValue = "No";
        if (calculation?.payload?.critical_illness === "1") {
          criticalIllnessValue = parseInt(calculation?.sum_assured) / 2;
        } else if (calculation?.payload?.critical_illness === "2") {
          criticalIllnessValue = calculation?.critical_sum;
        }
        tableData.push(["Critical Illness", criticalIllnessValue]);
      }

      // Verify autoTable import
      if (!autoTable) {
        throw new Error("autoTable import failed");
      }

      // Generate Table using explicit function call
      autoTable(doc, {
        startY: 30,
        head: [['Field', 'Value']],
        body: tableData,
        theme: 'grid',
        headStyles: { fillColor: [0, 78, 143] }, // Custom header color (blue)
      });

      // Save the PDF
      doc.save("Premium_Calculation.pdf");
      console.log("PDF saved successfully.");
    } catch (error) {
      console.error("Error generating PDF:", error);
      alert("Error generating PDF: " + error.message);
    }
  };

  return (
    <>
      {" "}
      <div className={isModal ? "p-2" : "contact-from"}>
        {!isModal && (
          <>
            {lang === "en" && (
              <h1 style={{ fontSize: "24px" }}>Choose Plan & Calculate Premium</h1>
            )}
            {lang === "bn" && (
              <h1 style={{ fontSize: "26px" }}>
                প্ল্যান নির্বাচন ও প্রিমিয়াম হিসাব{" "}
              </h1>
            )}
          </>
        )}
        <div className={isModal ? "contact-main p-0" : "contact-main"}>
          <div className="row">
            {state.message && (
              <div className="col-sm-12">
                <div
                  className={`alert alert-${state.message_type} alert-dismissible fade show`}
                  role="alert"
                >
                  {state.message}
                  <button
                    type="button"
                    className="close"
                    data-dismiss="alert"
                    aria-label="Close"
                    onClick={handleMessageClose}
                  >
                    <span aria-hidden="true">&times;</span>
                  </button>
                </div>
              </div>
            )}
          </div>

          {/* --------------------------- premium calculator form start ----------------- */}
          <div className="row">
            <div className="col-md-12">
              <form>
                {/* Single Row for All Fields */}
                <div className="row">
                  {/* Date of Birth */}
                  <div className="col-md-4">
                    <div className="form-group">
                      <label style={{ fontSize: "14px" }}>
                        <LangData keyname="label_premium_calculator_dob" />
                        <span>*</span>
                      </label>
                      <div>
                        <DateInput
                          handlePoliciesBasedOnAge={fetchPolicyData}
                          id="dateofbirth"
                          defaultDate={initialValues?.dob}
                        />
                      </div>
                      {validator.dob && (
                        <span className="help-block form-text text-danger">
                          {validator.dob}
                        </span>
                      )}
                    </div>
                  </div>
                  {/* Date of Commencement */}
                  <div className="col-md-4">
                    <div className="form-group">
                      <label style={{ fontSize: "14px" }}>
                        <LangData keyname="label_premium_calculator_doc" />
                        <span>*</span>
                      </label>
                      <div>
                        <DateInput
                          handlePoliciesBasedOnAge={fetchPolicyData}
                          id="dateofstartPolicy"
                          defaultDate={initialValues?.doc || new Date()}
                        />
                      </div>
                      {validator.doc && (
                        <span className="help-block form-text text-danger">
                          {validator.doc}
                        </span>
                      )}
                    </div>
                  </div>

                  {/* Gender */}

                  <div className="col-md-4">
                    <div className="form-group">
                      <label style={{ fontSize: "14px" }}>
                        <LangData keyname="label_policy_holder_gender" />
                        <span>*</span>
                      </label>
                      <select
                        ref={genderRef}
                        // id="genderRefValue"
                        onChange={fetchPolicyData}
                        className={`form-control from-style ${validator.gender ? "input-error" : ""
                          }`}
                      >
                        <option value="">{t("label_select")}</option>
                        <option value="M">Male</option>
                        <option value="F">Female</option>
                        <option value="O">Others</option>
                      </select>

                      {validator.gender && (
                        <span className="help-block form-text text-danger">
                          {validator.gender}
                        </span>
                      )}
                    </div>
                  </div>

                  {/* Plan Name */}
                  <div className="col-md-4">
                    <div className="form-group">
                      <label style={{ fontSize: "14px" }}>
                        <LangData keyname="label_premium_calculator_plan_name" />
                        <span>*</span>
                      </label>
                      <select
                        ref={policyRef}
                        className={`form-control from-style ${validator.policy ? "input-error" : ""
                          }`}
                        onChange={handlePolicyChange}
                      >
                        <option value="">{t("label_select_policy")}</option>
                        {policyData?.map((policy) => (
                          <option key={policy.plan} value={policy.plan}>
                            {policy.planName}
                          </option>
                        ))}
                      </select>

                      {validator.policy && (
                        <span className="help-block form-text text-danger">
                          {validator.policy}
                        </span>
                      )}
                    </div>
                  </div>
                  {/* Mode */}
                  <div className="col-md-4">
                    <div className="form-group">
                      <label style={{ fontSize: "14px" }}>
                        <LangData keyname="label_premium_calculator_mode" />
                        <span>*</span>
                      </label>
                      <select
                        ref={modeRef}
                        className={`form-control from-style ${validator.mode ? "input-error" : ""
                          }`}
                        onChange={handleModeChange}
                      >
                        <option value="">{t("label_select_mode")}</option>
                        {modesData.map((mode) => (
                          <option key={mode} value={mode}>
                            {modeMapping[mode] || mode}
                          </option>
                        ))}
                      </select>

                      {validator.mode && (
                        <span className="help-block form-text text-danger">
                          {validator.mode}
                        </span>
                      )}
                    </div>
                  </div>

                  {/* Term */}
                  {styleinfo.licterm !== "none" && (
                    <div className="col-md-4">
                      <div className="form-group">
                        <label style={{ fontSize: "14px" }}>
                          <LangData keyname="label_premium_calculator_term" />
                          <span>*</span>
                        </label>
                        <select
                          ref={termRef}
                          className={`form-control from-style ${validator.term ? "input-error" : ""
                            }`}
                          onChange={handleTermChange}
                        >
                          <option value="">{t("label_select_terms")}</option>
                          {termsOption?.length > 0 ? (
                            termsOption?.map((term) => (
                              <option
                                key={term.policyTerm}
                                value={term.policyTerm}
                              >
                                {term.policyTerm}
                              </option>
                            ))
                          ) : (
                            <option disabled>No terms available</option>
                          )}
                        </select>

                        {validator.term && (
                          <span className="help-block form-text text-danger">
                            {validator.term}
                          </span>
                        )}
                      </div>
                    </div>
                  )}
                  {/* Premium payment Term */}
                  {styleinfo.premiumPayment_term !== "none" && (
                    <div className="col-md-4">
                      <div className="form-group">
                        <label style={{ fontSize: "14px" }}>
                          <LangData keyname="label_premium_payment_calculator_term" />
                          <span>*</span>
                        </label>
                        <select
                          ref={premiumPayingTermsRefs}
                          className={`form-control from-style ${validator.premiumPayingTerms ? "input-error" : ""
                            }`}
                          onChange={handlePremiumPayingTermChange}
                        >
                          <option value="">
                            {t("label_select_premium_paying_terms")}
                          </option>
                          {premiumPayingTermsData?.map((term) => (
                            <option key={term} value={term}>
                              {term}
                            </option>
                          ))}
                        </select>

                        {validator.premiumPayingTerms && (
                          <span className="help-block form-text text-danger">
                            {validator.premiumPayingTerms}
                          </span>
                        )}
                      </div>
                    </div>
                  )}

                  {/* Parent Age */}
                  {styleinfo.parentage !== "none" && (
                    <div className="col-md-4">
                      <div className="form-group">
                        <label style={{ fontSize: "14px" }}>
                          <LangData keyname="label_premium_calculator_date_of_birth_parents" />
                          <span>*</span>
                        </label>
                        <DateInput
                          id="parent_age"
                          handlePoliciesBasedOnAge={handleParentAgeValidation}
                        />
                        {validator.parentage && (
                          <span className="help-block form-text text-danger">
                            {validator.parentage}
                          </span>
                        )}
                      </div>
                    </div>
                  )}

                  {/* Parent Gender */}
                  {styleinfo.parentage !== "none" && (
                    <div className="col-md-4">
                      <div className="form-group">
                        <label style={{ fontSize: "14px" }}>
                          <LangData keyname="label_premium_calculator_parent_gender" />
                          <span>*</span>
                        </label>
                        <select
                          ref={propGenderRef}
                          defaultValue="M"
                          className="form-control from-style"
                        >
                          <option value="M">{t("label_male")}</option>
                          <option value="F">{t("label_female")}</option>
                        </select>
                      </div>
                    </div>
                  )}

                  {/* PWB */}
                  {styleinfo.parentage !== "none" && (
                    <div className="col-md-4">
                      <div className="form-group">
                        <label style={{ fontSize: "14px" }}>
                          <LangData keyname="label_premium_calculator_pwb" />
                          <span>*</span>
                        </label>
                        <select
                          ref={pwbFlagRef}
                          defaultValue={selectedPolicy?.plan?.toString() === "807" ? "N" : "Y"}
                          disabled={selectedPolicy?.plan?.toString() === "807"}
                          className="form-control from-style"
                        >
                          <option value="Y">{t("label_yes")}</option>
                          <option value="N">{t("label_no")}</option>
                        </select>
                      </div>
                    </div>
                  )}

                  {/* Sum Assured */}
                  <div className="col-md-4">
                    <div className="form-group">
                      <label style={{ fontSize: "14px" }}>
                        <LangData keyname="label_premium_calculator_sum_assured" />
                        <span>*</span>
                      </label>
                      <input
                        type="text"
                        ref={sumAssuredRef}
                        className={`form-control from-style ${validator.sum_assured ? "input-error" : ""
                          }`}
                        placeholder={t("placeholder_sum_assured")}
                        onInput={() => {
                          handleSumAssuredValidation();
                          if (termRiderRef.current?.value) {
                             handleTermRiderValidation();
                          }
                        }}
                      />

                      {validator.sum_assured && (
                        <span className="help-block form-text text-danger">
                          {validator.sum_assured}
                        </span>
                      )}
                    </div>
                  </div>

                  {/* Term Rider */}
                  {styleinfo.term_rider !== "none" && (
                  <div className="col-md-4">
                    <div className="form-group">
                      <label style={{ fontSize: "14px" }}>
                        Term Rider Sum Assured
                      </label>
                      <input
                        type="number"
                        ref={termRiderRef}
                        className={`form-control from-style ${validator.term_rider ? "input-error" : ""
                          }`}
                        placeholder="Enter Term Rider Amount"
                        onInput={handleTermRiderValidation}
                      />

                      {validator.term_rider && (
                        <span className="help-block form-text text-danger">
                          {validator.term_rider}
                        </span>
                      )}
                    </div>
                  </div>
                  )}

                  {/* Accidental Coverage */}
                  {styleinfo.accidental !== "none" && (
                    <div className="col-md-4">
                      <div className="form-group">
                        <label style={{ fontSize: "14px" }}>
                          <LangData keyname="label_premium_calculator_accidental_coverage" />
                          <span>*</span>
                        </label>
                        <select
                          ref={accidentalCoverRef}
                          className={`form-control from-style ${validator.accidental_cover ? "input-error" : ""
                            }`}
                        >
                          <option value="">{t("label_select")}</option>
                          <option value="1">Yes</option>
                          <option value="0">No</option>
                        </select>

                        {validator.accidental_cover && (
                          <span className="help-block form-text text-danger">
                            {validator.accidental_cover}
                          </span>
                        )}
                      </div>
                    </div>
                  )}

                  {/* Critical Illness */}
                  {styleinfo.critical !== "none" && (
                    <div className="col-md-4">
                      <div className="form-group">
                        <label style={{ fontSize: "14px" }}>
                          <LangData keyname="label_premium_calculator_critical_illness" />
                          <span>*</span>
                        </label>
                        <select
                          ref={criticalIllnessRef}
                          defaultValue={selectedPolicy?.plan?.toString() === "807" ? "0" : ""}
                          disabled={selectedPolicy?.plan?.toString() === "807"}
                          className={`form-control from-style ${validator.critical_illness ? "input-error" : ""
                            }`}
                          onChange={handleCriticalIllnessChange}
                        >
                          <option value="">{t("label_select")}</option>
                          <option value="1">Yes</option>
                          <option value="0">No</option>
                          <option value="2">Other</option>
                        </select>

                        {validator.critical_illness && (
                          <span className="help-block form-text text-danger">
                            {validator.critical_illness}
                          </span>
                        )}
                      </div>
                    </div>
                  )}

                  {/* Critical Sum Assured */}
                  {styleinfo.critical_sum !== "none" && (
                    <div className="col-md-4">
                      <div className="form-group">
                        <label style={{ fontSize: "14px" }}>
                          <LangData keyname="label_premium_calculator_critical_illness_sum_assured" />
                          <span>*</span>
                        </label>
                        <input
                          // type="number"
                          type="text"
                          // min="1"
                          // max="2000000" //validation will be here for less than  50% of Sum assured
                          ref={criticalSumRef}
                          className={`form-control from-style ${validator.critical_sum ? "input-error" : ""
                            }`}
                          placeholder={t("placeholder_critical_sum_assured")}
                        />

                        {validator.critical_sum && (
                          <span className="help-block form-text text-danger">
                            {validator.critical_sum}
                          </span>
                        )}
                      </div>
                    </div>
                  )}
                  {/* Hospital rider benefit */}
                  {styleinfo.hospital_rider !== "none" && (
                    <div className="col-md-4">
                      <div className="form-group">
                        <label style={{ fontSize: "14px" }}>
                          <LangData keyname="label_premium_calculator_hostpital_rider_benifit" />
                          <span>*</span>
                        </label>
                        <select
                          ref={hospitalRiderRef}
                          // onChange={(e) => fetchPolicyData(e)}
                          className={`form-control from-style ${validator.gender ? "input-error" : ""
                            }`}
                        >
                          <option value="">{t("label_select")}</option>
                          <option value="0">NOHCB</option>
                          <option value="1">100,000</option>
                          <option value="2">200,000</option>
                          <option value="3">300,000</option>
                          <option value="4">400,000</option>
                        </select>

                        {validator.hospital_rider && (
                          <span className="help-block form-text text-danger">
                            {validator.hospital_rider}
                          </span>
                        )}
                      </div>
                    </div>
                  )}
                </div>
              </form>

              {/* Submit Button */}
              <div className="submit mt-3">
                <input
                  type="button"
                  value={lang === "bn" ? "ক্যালকুলেট" : "Calculate"}
                  className="btn btn-primary submit-button"
                  name="submit"
                  disabled={disCal}
                  onClick={handleSubmit}
                />
              </div>
            </div>
          </div>
          {/* --------------------------- premium calculator form end ----------------- */}
          <div className="">
            {calculation?.message === "Success" && (
              <div className="calculated-result">
                <table className="table table-bordered">
                  <thead className="thead-dark">
                    <tr>
                      <th>Premium Calculator Field</th>
                      <th>Premium Calculator Value</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>
                        <LangData keyname="label_premium_calculator_plan_name" />
                      </td>
                      <td>{calculation?.policy}</td>
                    </tr>
                    <tr>
                      <td>
                        <LangData keyname="label_premium_calculator_customer_age" />
                      </td>
                      <td>{calculation?.age}</td>
                    </tr>
                    <tr>
                      <td>
                        <LangData keyname="label_premium_calculator_sum_assured" />
                      </td>
                      <td>{calculation?.payload?.sum_assured}</td>
                    </tr>
                    <tr>
                      <td>
                        <LangData keyname="label_premium_calculator_term" />
                      </td>
                      <td>{calculation?.payload?.term}</td>
                    </tr>
                    <tr>
                      <td>
                        <LangData keyname="label_premium_calculator_mode" />
                      </td>
                      <td>
                        {modeMapping[calculation?.payload?.mode] ||
                          calculation?.payload?.mode}
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <LangData keyname="label_premium_calculator_approximate_premium" />
                      </td>
                      <td>{calculation?.totPrem ?? "0"}</td>
                    </tr>
                    {/* <tr>
                      <td>
                        <LangData keyname="label_premium_calculator_critical_illness" />
                      </td>
                      <td>{calculation?.payload?.critical_illness === "0"
                              ? "No"
                              : "Yes"}</td>
                    </tr>
                    <tr>
                      <td>
                        <LangData keyname="label_premium_calculator_hostpital_rider_benifit" />
                      </td>
                      <td>{calculation?.payload?.hospital_rider === "0"
                              ? "No"
                              : "Yes"}</td>
                    </tr> */}
                    {/* ------------------------------- */}

                    {calculation?.payload?.polMode !== "N" &&
                      !["803", "809", "816"].includes(
                        String(
                          calculation?.payload?.plan ||
                            calculation?.payload?.policy ||
                            ""
                        )
                      ) && (
                        <tr>
                          <td>
                            {lang === "bn"
                              ? "টার্ম রাইডার সাম অ্যাসুরড"
                              : "Term Rider Sum Assured"}
                          </td>
                          <td>
                            {(calculation?.payload?.trSa &&
                              calculation?.payload?.trSa !== "0" &&
                              calculation?.payload?.trSa !== 0) ||
                            (calculation?.payload?.term_rider &&
                              calculation?.payload?.term_rider !== "0" &&
                              calculation?.payload?.term_rider !== 0)
                              ? calculation?.payload?.trSa ||
                                calculation?.payload?.term_rider
                              : "No"}
                          </td>
                        </tr>
                      )}

                    {calculation?.payload?.polMode !== "N" &&
                      (calculation?.payload?.plan === "802" ||
                        calculation?.payload?.plan === "801" ||
                        calculation?.payload?.plan === "804" ||
                        calculation?.payload?.plan === "805" ||
                        calculation?.payload?.plan === "806" ||
                        calculation?.payload?.plan === "808" ||
                        calculation?.payload?.plan === "813" ||
                        calculation?.payload?.plan === "815" ||
                        calculation?.payload?.plan === "814") && (
                        <tr>
                          <td>
                            <LangData keyname="label_premium_calculator_accidental_coverage" />
                          </td>
                          <td>
                            {calculation?.payload?.accidental_cover === "0"
                              ? "No"
                              : "Yes"}
                          </td>
                        </tr>
                      )}

                    {calculation?.payload?.polMode !== "N" &&
                      (calculation?.payload?.plan === "802" ||
                        calculation?.payload?.plan === "804" ||
                        calculation?.payload?.plan === "805" ||
                        calculation?.payload?.plan === "806" ||
                        calculation?.payload?.plan === "807" ||
                        calculation?.payload?.plan === "808" ||
                        calculation?.payload?.plan === "813" ||
                        calculation?.payload?.plan === "815" ||
                        calculation?.payload?.plan === "814") && (
                        <tr>
                          <td>
                            <LangData keyname="label_premium_calculator_hostpital_rider_benifit" />
                          </td>
                          <td>
                            {calculation?.payload?.hcbSa === "0"
                              ? "No"
                              : calculation?.payload?.hcbSa}
                          </td>
                        </tr>
                      )}
                    {calculation?.payload?.polMode !== "N" &&
                      (calculation?.payload?.plan === "802" ||
                        calculation?.payload?.plan === "804" ||
                        calculation?.payload?.plan === "806" ||
                        calculation?.payload?.plan === "807" ||
                        calculation?.payload?.plan === "808" ||
                        calculation?.payload?.plan === "813" ||
                        calculation?.payload?.plan === "814" ||
                        calculation?.payload?.plan === "815") && (
                        <tr>
                          <td>
                            <LangData keyname="label_premium_calculator_critical_illness" />
                          </td>
                          <td>
                            {calculation?.payload?.critical_illness === "0"
                              ? "No"
                              : calculation?.payload?.critical_illness === "1"
                                ? parseInt(calculation?.sum_assured) / 2
                                : calculation?.payload?.critical_illness === "2"
                                  ? calculation?.critical_sum
                                  : "0"}
                          </td>
                        </tr>
                      )}
                  </tbody>
                </table>
                {isModal ? (
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "flex-end",
                      marginTop: "20px",
                      gap: "10px",
                    }}
                  >
                    <button
                      type="button"
                      className="btn btn-secondary m-0"
                      onClick={onClose}
                    >
                      Cancel
                    </button>
                    <button
                      type="button"
                      className="btn btn-primary m-0"
                      style={{
                        backgroundColor: "#004e8f",
                        borderColor: "#004e8f",
                        fontWeight: "bold",
                        padding: "8px 24px",
                      }}
                      onClick={() => {
                        if (onApply) {
                          onApply(calculation);
                        }
                      }}
                    >
                      Apply & Update Plan
                    </button>
                  </div>
                ) : (
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "flex-start",
                      marginTop: "20px",
                      gap: "10px",
                    }}
                  >
                    <PolicyBuyButton />
                    <button
                      className="btn btn-success m-0"
                      style={{ marginLeft: "10px" }}
                      onClick={handleDownloadExcel}
                    >
                      Download Excel
                    </button>
                    <button
                      className="btn btn-success m-0"
                      style={{ marginLeft: "10px" }}
                      onClick={handleDownloadPDF}
                    >
                      Download PDF
                    </button>
                  </div>
                )}
              </div>
            )}
          </div>
        </div>
      </div>
      {!isModal && (
        <PremiumCalculatorDataPreview
          calculation={calculation}
          data_loop={data_loop}
          total_20={total_20}
          total_40={total_40}
          final_premium_amount={final_premium_amount}
          totalFac={totalFac}
          totalSurvivalBenefit={totalSurvivalBenefit}
        />
      )}
    </>
  );
};

export default PremiumcalCulatorform;
